// extracted by mini-css-extract-plugin
module.exports = {"title":"GreyTitle_title__2paUm"};